/*
 * <splide-component> wrapper around Splide (MIT, assets/splide.min.js).
 * Reads the same data-* options the Soulyshine gallery and review snippets already use.
 */
(function () {
  'use strict';
  if (customElements.get('splide-component')) return;

  function int(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  class SplideComponent extends HTMLElement {
    connectedCallback() {
      this.initSlider();
      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:load', () => this.initSlider());
      }
    }

    disconnectedCallback() {
      if (this.splide) {
        this.splide.destroy(true);
        this.splide = null;
      }
    }

    initSlider() {
      if (typeof window.Splide !== 'function') {
        if (!this.__retried) {
          this.__retried = true;
          window.addEventListener('load', () => this.initSlider(), { once: true });
        }
        return;
      }
      var container = this.querySelector('.splide');
      if (!container) return;
      if (this.splide) this.splide.destroy(true);

      var d = this.dataset;
      var type = d.type || 'slide';
      var typeMobile = d.typeMobile || type;
      var arrowsColor = d.arrowsColor ? ' color-' + d.arrowsColor : '';
      var dotsColor = d.dotsColor ? ' color-' + d.dotsColor + ' dots-custom-color' : '';
      var paddingCalcDesktop = d.paddingCalcDesktop === 'true';
      var paddingCalcMobile = d.paddingCalcMobile === 'true';
      var rightDesktop = int(d.sidePaddingDesktop, 0);
      var rightMobile = int(d.sidePaddingMobile, 0);

      this.config = {
        type: type,
        direction: d.direction || (document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr'),
        rewind: type === 'fade',
        autoplay: d.autoplay === 'true',
        interval: int(d.autoplaySpeed, 5) * 1000,
        drag: d.drag === 'false' ? false : d.drag === 'free' ? 'free' : true,
        focus: d.focus || 0,
        trimSpace: d.trimSpace !== 'false',
        arrows: d.arrows !== 'false',
        pagination: d.pagination !== 'false',
        omitEnd: d.omitEnd !== 'false',
        perPage: int(d.slidesDesktop, 3),
        perMove: int(d.perMoveDesktop, 1),
        autoWidth: d.autoWidth === 'true',
        gap: int(d.gapDesktop, 30),
        padding: { left: paddingCalcDesktop ? 0 : rightDesktop, right: rightDesktop },
        destroy: d.destroyDesktop === 'true',
        classes: { arrow: 'splide__arrow' + arrowsColor, page: 'splide__pagination__page' + dotsColor },
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        breakpoints: {
          749: {
            omitEnd: d.omitEnd !== 'false',
            type: typeMobile,
            perPage: int(d.slidesMobile, 1),
            perMove: int(d.perMoveMobile, 1),
            gap: int(d.gapMobile, 15),
            padding: { left: paddingCalcMobile ? 0 : rightMobile, right: rightMobile },
            destroy: d.destroyMobile === 'true',
          },
        },
      };

      // Arrows/pagination render inside the snippet-provided containers when present.
      var arrowsContainer = this.querySelector('.splide__arrows');
      var paginationContainer = this.querySelector('.splide__pagination');
      if (arrowsContainer && !arrowsContainer.querySelector('.splide__arrow')) {
        arrowsContainer.innerHTML =
          '<button class="splide__arrow splide__arrow--prev' + arrowsColor + '" type="button" aria-label="Previous slide"><svg viewBox="0 0 40 40" width="40" height="40" aria-hidden="true"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg></button>' +
          '<button class="splide__arrow splide__arrow--next' + arrowsColor + '" type="button" aria-label="Next slide"><svg viewBox="0 0 40 40" width="40" height="40" aria-hidden="true"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg></button>';
      }
      if (arrowsContainer) this.config.arrows = this.config.arrows && true;
      if (paginationContainer) this.config.pagination = this.config.pagination && true;

      var splide = new window.Splide(container, this.config);
      var self = this;
      function setActiveHeight(slide) {
        if (!slide) return;
        self.style.setProperty('--active-slide-height', slide.offsetHeight + 'px');
      }
      splide.on('mounted', function () {
        var slide = splide.Components.Elements.slides[splide.index];
        if (slide) {
          slide.classList.add('is-instant-active');
          setActiveHeight(slide);
        }
        window.addEventListener('resize', function () {
          setActiveHeight(splide.Components.Elements.slides[splide.index]);
        });
      });
      splide.on('move', function () {
        var slides = splide.Components.Elements.slides;
        slides.forEach(function (s) { s.classList.remove('is-instant-active'); });
        var active = slides[splide.index];
        if (active) {
          active.classList.add('is-instant-active');
          setActiveHeight(active);
        }
      });
      if (d.pauseVideos === 'true') {
        splide.on('hidden', function (slideObj) {
          var video = slideObj.slide.querySelector('video');
          if (video) video.pause();
        });
      }
      splide.mount();
      this.splide = splide;
    }
  }

  customElements.define('splide-component', SplideComponent);
})();
